import {useRouteQuery} from '@github-ui/react-core/future/use-route-query'
import {pullRequestsLayoutRoute} from '../../routes/layout-route'
import {useRouteQueryKey} from '@github-ui/react-core/future/use-route-query-key'
import {produce} from 'immer'
import {useQueryClient} from '@github-ui/react-query'

export interface ThreadCounts {
  unresolvedThreads: number
  resolvedThreads: number
  totalThreads: number
}

export function useThreadCountsQuery() {
  return useRouteQuery(pullRequestsLayoutRoute, 'tabCounts', {
    select: (data): ThreadCounts | undefined =>
      data.unresolvedConversationCount !== undefined && data.resolvedConversationCount !== undefined
        ? {
            unresolvedThreads: data.unresolvedConversationCount,
            resolvedThreads: data.resolvedConversationCount,
            totalThreads: data.unresolvedConversationCount + data.resolvedConversationCount,
          }
        : undefined,
  })
}

/** @deprecated use `useThreadCountsQuery().data?.unresolvedThreads` instead. */
export function useUnresolvedConversationCount() {
  return useRouteQuery(pullRequestsLayoutRoute, 'tabCounts', {select: data => data.unresolvedConversationCount}).data
}

export function useThreadCountActions() {
  const tabCountsQueryKey = useRouteQueryKey(pullRequestsLayoutRoute, 'tabCounts')
  if (!tabCountsQueryKey) throw new Error('Missing `tabCounts` route query')

  const queryClient = useQueryClient()

  return {
    countNewThread: (resolved = false) =>
      queryClient.setQueryData(tabCountsQueryKey, data =>
        produce(data, draft => {
          if (resolved && draft?.resolvedConversationCount !== undefined) draft.resolvedConversationCount++

          if (!resolved && draft?.unresolvedConversationCount !== undefined) draft.unresolvedConversationCount++
        }),
      ),
    countThreadResolved: () =>
      queryClient.setQueryData(tabCountsQueryKey, data =>
        produce(data, draft => {
          if (draft?.resolvedConversationCount !== undefined) draft.resolvedConversationCount++

          if (draft?.unresolvedConversationCount !== undefined && draft.unresolvedConversationCount > 0)
            draft.unresolvedConversationCount--
        }),
      ),
    countThreadUnresolved: () =>
      queryClient.setQueryData(tabCountsQueryKey, data =>
        produce(data, draft => {
          if (draft?.resolvedConversationCount !== undefined && draft.resolvedConversationCount > 0)
            draft.resolvedConversationCount--

          if (draft?.unresolvedConversationCount !== undefined) draft.unresolvedConversationCount++
        }),
      ),
    countDeletedThread: (wasResolved: boolean) =>
      queryClient.setQueryData(tabCountsQueryKey, data =>
        produce(data, draft => {
          if (wasResolved && draft?.resolvedConversationCount !== undefined && draft.resolvedConversationCount > 0)
            draft.resolvedConversationCount--

          if (
            !wasResolved &&
            draft?.unresolvedConversationCount !== undefined &&
            draft?.unresolvedConversationCount > 0
          )
            draft.unresolvedConversationCount--
        }),
      ),
  }
}
